module.exports = __webpack_public_path__ + "static/media/pizza.932b12fa.png";